"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHelpModal = void 0;
var _react = require("react");
var _tracking = require("../tracking");
const useHelpModal = offerId => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const openHelpModal = () => {
    setIsVisible(true);
    (0, _tracking.trackHelpModalShow)(offerId);
  };
  const closeHelpModal = () => {
    setIsVisible(false);
  };
  return {
    isHelpModalVisible: isVisible,
    openHelpModal,
    closeHelpModal
  };
};
exports.useHelpModal = useHelpModal;